import React from 'react';
import { lastSevenQuestions } from '../../common/constant/data';
import { useTranslation } from 'react-i18next';
const LevelRadioSelectionlastSeven = ({ formik }) => {
  const { t } = useTranslation()
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 gap-5 items-start  max-h-[50vh] mt-8   overflow-y-auto">
      {lastSevenQuestions.map((question, index) => (
        <div key={index} className="w-full">
          <p className="text-[13px] font-medium text-white text-left mb-3">
            {index + 8}. {t(`questions.${question?.keyName}`)}
          </p>
          <div className="flex gap-3 items-center">
            {question?.options?.map((option, i) => (
              <label
                key={`${index}-${i}`}
                className="flex items-center space-x-2 cursor-pointer pl-2"
              >
                <div className="w-[25px] h-[25px]">
                  <input
                    type="radio"
                    name={question.keyName}
                    value={option.value}
                    checked={formik.values[question.keyName] === option.value}
                    onChange={formik.handleChange}
                    className="w-4 h-4 custom-radio"
                  />
                </div>

                <span className="text-[12px] font-normal text-[#F9DCD4]">
                  {t(`options.${option.label}`)}
                </span>
              </label>
            ))}
          </div>
          {formik.touched[question.keyName] && formik.errors[question.keyName] && (
            <p className="text-[11px] text-left text-red-500 mt-1">
              {formik.errors[question.keyName]}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default LevelRadioSelectionlastSeven;
